enum ClaimTypeComprehensiveEnum {
  FULLY = 'fully',
  GLASS_DAMAGE = 'glassDamage',
  PARTIALLY = 'partially'
}

export default ClaimTypeComprehensiveEnum;
